import { useAuth } from './useAuth';

/**
 * #2104 — true when the "Split Time at checkout" feature gate is enabled
 * (django-flags split_time_at_checkout, surfaced on the auth response, default
 * OFF). When false, the checkout screen shows only the tracked timer time and
 * exposes no editable time allocation. Reads the cached flag — no extra request.
 */
export function useSplitTimeEnabled(): boolean {
  const { user } = useAuth();
  return !!user?.split_time_at_checkout;
}
